import { useCartMutationVariables } from "@/core/api/graphql/cart/composables";
import { useMutation } from "@/core/api/graphql/composables";
import { RefreshCartItemsPriceDocument } from "@/core/api/graphql/types";
import type { CartIdFragment } from "@/core/api/graphql/types";
import type { MaybeRef } from "vue";

export function useRefreshCartItemsPriceMutation(cart?: MaybeRef<CartIdFragment | undefined>) {
  return useMutation(RefreshCartItemsPriceDocument, useCartMutationVariables(cart));
}
